import React, { useState } from "react";

import { Button } from "antd";
import Modal from "antd/es/modal/Modal";
import moment from "moment";

import "./NewSampleDatePickerModal.css";

const DATE_OPTIONS_COUNT = 6;

function generateDateOptions() {
  return Array.from({ length: DATE_OPTIONS_COUNT }, (_, i) => moment().add(i, "days"));
}

export default function NewSampleDatePickerModal({ onCancel, onContinue }) {
  const dates = generateDateOptions();
  const [selectedDate, setSelectedDate] = useState(null);

  return (
    <Modal
      open
      maskClosable={false}
      closable={false}
      centered
      footer={null}
      wrapClassName="NewSampleDatePickerModal"
      className="NewSampleDatePickerModal"
      width="520px"
    >
      <div className="NewSampleDatePickerModal__Body">
        <div className="NewSampleDatePickerModal__Content">
          <div className="NewSampleDatePickerModal__HeadingGroup">
            <span className="NewSampleDatePickerModal__Title">
              When will you submit the new sample?
            </span>
            <span className="NewSampleDatePickerModal__Subtitle">
              Select the expected submission date.
            </span>
          </div>

          <div className="NewSampleDatePickerModal__DateRow">
            {dates.map((date, i) => {
              const isSelected = selectedDate && date.isSame(selectedDate, "day");
              const isToday = i === 0;
              return (
                <div key={i} className="NewSampleDatePickerModal__DatePillWrapper">
                  <div
                    className={[
                      "NewSampleDatePickerModal__DatePill",
                      isSelected ? "NewSampleDatePickerModal__DatePill--selected" : "",
                    ].filter(Boolean).join(" ")}
                    onClick={() => setSelectedDate(date)}
                  >
                    <span className="NewSampleDatePickerModal__DatePillText">
                      {date.format("MMM")}
                      <br />
                      {date.format("D")}
                    </span>
                  </div>
                  {isToday && (
                    <span className="NewSampleDatePickerModal__TodayLabel">Today</span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="NewSampleDatePickerModal__Footer">
        <Button type="default" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          type="primary"
          disabled={!selectedDate}
          onClick={() => onContinue(selectedDate)}
        >
          Continue
        </Button>
      </div>
    </Modal>
  );
}
